import { render, staticRenderFns } from "./AdminStatCards.vue?vue&type=template&id=748f9b12"
import script from "./AdminStatCards.vue?vue&type=script&lang=js"
export * from "./AdminStatCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports